import { render, staticRenderFns } from "./AddDocumentTable.vue?vue&type=template&id=55a32a62&scoped=true&"
import script from "./AddDocumentTable.vue?vue&type=script&lang=js&"
export * from "./AddDocumentTable.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentTable.vue?vue&type=style&index=0&id=55a32a62&scoped=true&lang=css&"
import style1 from "./AddDocumentTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a32a62",
  null
  
)

export default component.exports